export default __webpack_public_path__ + "static/submittable-logo__white-a1674b688212d1fa5d86dc95fd47ff68.svg";